/**
 * Tipos de períodos de descanso.
 */
export enum TipoPeriodoDescanso {
  Ferias = 0,
  FolgaNatalicia = 1,
  AbonoTrabalhado = 2,
  AbonoEspecial = 3,
  LicencaPremio = 4,
  LicencaOutros = 5,
  Afastamento = 6,
}